import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Address } from '../../../../../../lib/address/Address';
import shortenString from '../../../../../../components/utils/ShortenString';
import { AddressDetailsView } from '../../../../../../components/Common/AddressDetailsView';
import { Fees, Rate, Estimates, Reward, RowWrapper, } from '../../../Withdraw/Presentation/QuoteEstimateRows';
export function DetailedEstimatesView({ quote, reward, values, variant, showReward, gasFee, slippage, tokenAddress, }) {
    return (_jsxs("div", { className: "flex flex-col w-full px-2", children: [variant === 'extended' && gasFee, _jsx(Fees, { quote: quote, values: values }), values.depositMethod !== 'deposit_address' && (_jsx(Rate, { fromAsset: values?.fromAsset, toAsset: values?.toAsset, rate: quote?.rate })), values.depositMethod === 'deposit_address' &&
                variant === 'extended' &&
                values?.fromAsset?.contract && (_jsx(ExchangeTokenContractView, { fromAsset: values?.fromAsset, network: values?.from, addressContent: tokenAddress })), variant === 'extended' &&
                values.depositMethod === 'wallet' &&
                slippage, _jsx(Estimates, { quote: quote }), showReward && reward && _jsx(Reward, { reward: reward })] }));
}
export const ExchangeTokenContractView = ({ fromAsset, network, addressContent, }) => {
    const isValidAddress = useMemo(() => {
        return (fromAsset?.contract &&
            network &&
            Address.isValid(fromAsset.contract, network));
    }, [fromAsset?.contract, network]);
    const shortAddress = useMemo(() => {
        if (!fromAsset?.contract)
            return '';
        if (network)
            return new Address(fromAsset.contract, network).toShortString();
        return shortenString(fromAsset.contract);
    }, [fromAsset?.contract, network]);
    return (_jsx(RowWrapper, { title: `${network?.display_name} - ${fromAsset?.asset}`, children: isValidAddress && fromAsset?.contract && network ? (_jsx("div", { className: "text-sm group/addressItem text-secondary-text", children: addressContent ?? (_jsx(AddressDetailsView, { address: fromAsset.contract, network: network, shouldShowChevron: false, readOnly: true })) })) : (_jsx("p", { className: "text-sm text-secondary-text", children: shortAddress })) }));
};
